export default "__VITE_ASSET__DLIjLNE4__"